export default __webpack_public_path__ + "static/media/org-name-typo-arrow.fac90910.svg";